/**************************************************************************
 * Created on Tue Aug 27 2024
 *
 *  # Honeywell Code Usage Policy
 *
 * **Honeywell Source Code Usage Policy Classification:** Highly Confidential
 *
 * [comment]: # (Options for above are "Inner Source", "General Application", "Highly Confidential", "Export Controlled")
 *
 * **This repository has multiple classifications:** Yes
 *
 * [comment]: # (Options for above are "Yes" when subfolders contain a separate policy,"No" when the whole repo has the same policy)
 *
 * **Honeywell confidential - For internal use only.
 *
 * Property of and copyright ownership by Honeywell International Inc. and/or its affiliates.
 *
 * Use of source code must follow all Honeywell policies including the [HCE Source Code Access Policy](http: //go.honeywell.com/hce-code-access-policy).
 *
 * External use or distribution prohibited without written approval per Honeywell policies**
 *
********************************************************************************/

import { useState } from "react";
import './index.scss';
import { Outlet } from "react-router-dom";
import SideBarUser from "../../../dashboard/side-bars/sidebar-user";
import { useDssContext } from "../../../../DSSContext";
import { MENUPOSITION } from "../../../dashboard/model";

export const UserLayoutTop = (): JSX.Element =>
{
    const active = ('active');
    const { pageHeading, className } = useDssContext();
    return (

        <div className="user-container-top">
            <div className="top-container">
                <div className={ `headingname ${ className }` }>{ pageHeading }</div>
                <SideBarUser active={ active }
                    onMenuClick={ () => { } }
                    data-testid="sidebaruser"
                    menuPosition={ MENUPOSITION.HORIZONTAL } />

            </div>
            <main className={ "outlet-container " + active }>
                <Outlet />
            </main>

        </div>

    );
};